var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"responsive-img",attrs:{"src":_vm.comingSoonImgPath,"alt":""}}),_c('v-style',[_vm._v(" html body, #app { background-image: linear-gradient(180deg, #6d1983 5% 10%, #530e63 45% 100%) !important; } ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }